import { Box, Container, Flex, Paper, Text } from "@mantine/core";
import { IconArrowLeft } from "@tabler/icons";
import BigLinkButton from "../../../../packages/ui2/components/BigLinkButton";
import CommentUI from "../../../../packages/ui2/components/CommentUI";
import { fetch_single_discuss } from "../../util/firebase_read";

const SingleDiscuss = ({ pageid, discuss }) => {
    console.log({ discuss });
    if (!!!discuss) return <Box>Nothing to discuss</Box>;

    const { actual_text, comment, created_at, id, user } = discuss;
    return (
        <Container my={30}>
            <Paper>
                <Flex>
                    <BigLinkButton
                        href={"/doubts"}
                        title={"Go Back"}
                        description={"Go to doubts clearing page "}
                        direction={"row-reverse"}
                        icon={<IconArrowLeft />}
                    />
                </Flex>
            </Paper>
            <CommentUI
                heading={actual_text}
                comment={comment}
                commentid={id}
                idx={0}
                created_at={created_at}
                user={user}
            />
        </Container>
    );
};

export async function getStaticPaths() {
    return {
        paths: [],
        fallback: "blocking", // can also be true or 'blocking'
    };
}

export async function getStaticProps({ params }) {
    const discussid = params.discussid;

    // pull the comment data
    // pull the comment type -> is from ask doubts or etc
    // pull the comment owner
    const discuss = await fetch_single_discuss(discussid);
    return {
        props: { pageid: discussid, discuss },
    };
}

export default SingleDiscuss;
